import { PitchLocationChartConfigDto, PitchLocationChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/SessionReport/BatterSingle/reportStore';
import PitchLocationChart from 'components/Charts/PitchLocationChart/PitchLocationChart';
import { pitchCalls, pitchTypeGroups, pitchTypes } from 'utilities/constants';
import {
  pitchCallToColor,
  pitchCallToTextColor,
  pitchTypeGroupTextToColor,
  pitchTypeGroupToColor,
  pitchTypeToColor,
  pitchTypeToTextColor,
} from 'utilities/colorHelpers';

function getGroupLabelColor(groupLabel: string) {
  return pitchTypeToColor[groupLabel] ?? pitchTypeGroupToColor[groupLabel] ?? pitchCallToColor[groupLabel];
}

function getGroupLabelTextColor(groupLabel: string) {
  return pitchTypeToTextColor[groupLabel] ?? pitchTypeGroupTextToColor[groupLabel] ?? pitchCallToTextColor[groupLabel];
}

const BatterSingleSessionPitchLocationChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<PitchLocationChartDataDto, PitchLocationChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  const groupLabelsToSimulate =
    chartConfig.pitchLocationGrouping === 'GroupOrType'
      ? selectedConfgValues.pitchGrouping === 'Types'
        ? pitchTypes
        : pitchTypeGroups
      : pitchCalls;

  return (
    <PitchLocationChart
      chartData={chartData?.datasets}
      basePlateOrientation={'BatterSide'}
      showStrikeZoneGrid={true}
      groupLabelsToSimulate={groupLabelsToSimulate}
      getGroupLabelColor={getGroupLabelColor}
      getGroupLabelTextColor={getGroupLabelTextColor}
      isLoading={isLoading}
    />
  );
};

export default BatterSingleSessionPitchLocationChart;
